import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { IoIosArrowRoundBack } from "react-icons/io";
import toast from 'react-hot-toast';
import { GetVideoDetailServices } from '../services/VideoServices';

const InfoItem = ({ label, value }) => (
  <div>
    <p className="text-xs text-gray-500 uppercase">{label}</p>
    <p className="text-sm font-semibold text-gray-800">{value}</p>
  </div>
)

function ProjectDetail() {

  const navigator = useNavigate()
  const { id } = useParams()

  const [state, setstate] = useState({})
  const [loader, setloader] = useState(true)
  const [heroImage, setHeroImage] = useState('')

  useEffect(() => {
    getDetail()
  }, [id])

  async function getDetail() {
    const data = await GetVideoDetailServices(id)
    if (data?.data?.datas?.length > 0) {
      const project = data.data.datas[0]
      setstate(project)
      setHeroImage(project?.banner || project?.images?.[0])
      setloader(false)
    } else {
      toast.error("We couldn't find the video based on your search")
      setTimeout(() => navigator('/'), 2000)
    }
  }

  if (loader) return null

  return (
    <div className="bg-white">

      {/* 🔙 Back */}
      <div
        className="flex items-center px-[5%] py-3 cursor-pointer"
        onClick={() => navigator(-1)}
      >
        <IoIosArrowRoundBack size={22} className="text-[#027d9b]" />
        <span className="ml-2 text-[12px] font-semibold text-[#027d9b]">
          Back to projects
        </span>
      </div>

      {/* 🖼 HERO IMAGE (CLEAN & SIMPLE) */}
      <div className="w-full h-[70vh] bg-black">
        <img
          src={`${process.env.REACT_APP_AWS_IMAGE_URL}${heroImage}`}
          className="object-cover w-full h-full"
          alt="Hero"
        />
      </div>

      {/* 🧩 THUMBNAILS (MINIMAL) */}
      {(state?.images?.length > 0 || state?.banner) && (
        <div className="px-[5%] mt-3">
          <div className="flex gap-2 overflow-x-auto">
            {[state?.banner, ...(state?.images || [])]
              .filter(Boolean)
              .map((img, index) => (
                <img
                  key={index}
                  src={`${process.env.REACT_APP_AWS_IMAGE_URL}${img}`}
                  onClick={() => setHeroImage(img)}
                  className={`h-[80px] w-[120px] object-cover cursor-pointer border 
                    ${heroImage === img ? 'border-black' : 'border-transparent'}
                  `}
                  alt="thumb"
                />
              ))}
          </div>
        </div>
      )}

      {/* ================================================= */}
      {/* 📄 CONTENT — LEFT 100% AS-IT-IS (NO CHANGE) */}
      {/* ================================================= */}

      <div className="w-[90%] md:w-[80%] mx-auto my-12 space-y-10">

        <div className="grid grid-cols-1 gap-4 p-6 bg-white shadow-lg rounded-2xl md:grid-cols-2">
          {state?.work && (
            <InfoItem label="Work" value={state?.work} />
          )}
          {state?.project_name && (
            <InfoItem label="Project Name" value={state?.project_name} />
          )}
          {state?.total_sqft && (
            <InfoItem label="Total Sqft" value={state?.total_sqft} />
          )}
          {state?.nature && (
            <InfoItem label="Nature" value={state?.nature} />
          )}
          {state?.scope && (
            <div className="md:col-span-2">
              <InfoItem label="Scope" value={state?.scope} />
            </div>
          )}
        </div>

        {(state?.video || state?.youtube_link) && (
          <div className="p-6 bg-white shadow-lg rounded-2xl">
            <h3 className="mb-4 text-lg font-bold">Project Walkthrough</h3>

            {state?.video && !state?.youtube_link && (
              <video
                className="w-full rounded-xl"
                src={`${process.env.REACT_APP_AWS_IMAGE_URL}${state?.video}`}
                controls
              />
            )}

            {state?.youtube_link && (
              <div className="relative w-full pt-[56.25%] rounded-xl overflow-hidden">
                <iframe
                  src={state?.youtube_link}
                  className="absolute top-0 left-0 w-full h-full"
                  allowFullScreen
                  title="Project Video"
                />
              </div>
            )}
          </div>
        )}

        {state?.images?.length > 0 && (
          <div>
            <h3 className="mb-4 text-lg font-bold">Gallery</h3>
            <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4">
              {state.images.map((img, i) => (
                <div
                  key={i}
                  className="overflow-hidden shadow-md rounded-xl group"
                >
                  <img
                    src={`${process.env.REACT_APP_AWS_IMAGE_URL}${img}`}
                    className="w-full h-[160px] object-cover transition-transform duration-500 group-hover:scale-110"
                    alt="Project"
                  />
                </div>
              ))}
            </div>
          </div>
        )}

      </div>
    </div>
  )
}

export default ProjectDetail








//=====>> Old one 

// import React, { useEffect, useState } from 'react'
// import { projectArr } from '../constants/AppConstant'
// import {  useNavigate, useParams } from 'react-router-dom'
// import { IoIosArrowRoundBack } from "react-icons/io";
// import toast from 'react-hot-toast';
// import { GetVideoDetailServices } from '../services/VideoServices';

// function ProjectDetail() {

//   const navigator = useNavigate()
//   const {id} = useParams()

//   const [state,setstate] = useState({})
//   const [loader,setloader] = useState(true)

//   useEffect(()=>{
//     getDetail()
//   },[id])


//   async function getDetail(){
//     const data =  await GetVideoDetailServices(id)
//     if(data?.data?.datas?.length > 0){
//       setloader(false)
//       setstate(data?.data?.datas[0])
//     }else{
//       toast.error("We couldn't find the video based on your search")
//       setTimeout(() => {
//          navigator('/')
//       }, 2000);
//     }
//   }

//   return (
//     <div>
//        <div className='flex bg-[#def9ff] px-[5%] py-[14px]'>
//         <div className='flex items-center cursor-pointer' onClick={()=>navigator(-1)}>
//         <IoIosArrowRoundBack color='#027d9b' />
//         <h6 className='text-[11px] ml-2 text-[#027d9b] font_bold'>Back to projects {}</h6>
//         </div>
//       </div>
//          {!loader && 
//          <>
//          <img src={`${process.env.REACT_APP_AWS_IMAGE_URL}${state?.banner}`} className={`w-screen  h-[90vh] ${(state?.image_type !== undefined && state?.image_type !== null && state?.image_type !== '')? 'object-contain' : 'object-cover'}`} />

//          <div className='w-[90%] md:w-[80%] mx-auto my-[5%] mb-[10%]'>
//             <h6 className='font_bold text-[25px]'>{state?.client}</h6>
//             {(state?.work !== '' && state?.work !== undefined) && <h6 className='font_normal text-[14px] mb-4'>{state?.work}</h6>}
//             {(state?.project_name !== '' && state?.project_name !== undefined) && <h6 className='font_normal text-[14px] mb-4'>PROJECT NAME : <span className='font_bold'>{state?.project_name}</span> </h6>}
//             {(state?.total_sqft !== '' && state?.total_sqft !== undefined) && <h6 className='font_normal text-[14px] mb-4'>TOTAL SFT : <span className='font_bold'>{state?.total_sqft}</span> </h6>}
//             {(state?.nature !== '' && state?.nature !== undefined) && <h6 className='font_normal text-[14px] mb-4'>NATURE OF THE PROJECT : <span className='font_bold'>{state?.nature}</span> </h6>}
//             {(state?.scope !== '' && state?.scope !== undefined) && <h6 className='font_normal text-[14px] mb-10'>SCOPE : {state?.scope}</h6>}

//             {(state?.video !== '' && state?.video !== null && state?.video !== undefined && (state?.youtube_link == '' || state?.youtube_link == null || state?.youtube_link == undefined) ) &&
//             <video className='w-full' src={`${process.env.REACT_APP_AWS_IMAGE_URL}${state?.video}`} controls />}
            
//             {(state?.youtube_link !== '' && state?.youtube_link !== null && state?.youtube_link !== undefined ) &&
//             <div className='w-[100%] h-[100%] bg-red-100'>
//                  <iframe src={state?.youtube_link} width={'100%'} allowFullScreen />
//             </div>
//              }
            

//             <div className='grid grid-cols-2 gap-5 md:grid-cols-4'>
//             {(state?.images !== '' && state?.images !== null && state?.images !== undefined && state.images.length > 0) &&
//             state?.images?.map((s)=>(
//               <img src={`${process.env.REACT_APP_AWS_IMAGE_URL}${s}`} className='w-[100%] h-[150px] object-cover' />
//             ))
//             }
//             </div>
//          </div>
//          </>}

//     </div>

//   )
// }

// export default ProjectDetail








//=============>>> Old one not modified decemember




// import React, { useEffect, useState } from 'react'
// import { projectArr } from '../constants/AppConstant'
// import {  useNavigate, useParams } from 'react-router-dom'
// import { IoIosArrowRoundBack } from "react-icons/io";
// import toast from 'react-hot-toast';
// import { GetVideoDetailServices } from '../services/VideoServices';

// function ProjectDetail() {

//   const navigator = useNavigate()
//   const {id} = useParams()

//   const [state,setstate] = useState({})
//   const [loader,setloader] = useState(true)

//   useEffect(()=>{
//     getDetail()
//   },[id])


//   async function getDetail(){
//     const data =  await GetVideoDetailServices(id)
//     if(data?.data?.datas?.length > 0){
//       setloader(false)
//       setstate(data?.data?.datas[0])
//     }else{
//       toast.error("We couldn't find the video based on your search")
//       setTimeout(() => {
//          navigator('/')
//       }, 2000);
//     }
//   }

//   return (
//     <div>
//        <div className='flex bg-[#def9ff] px-[5%] py-[14px]'>
//         <div className='flex items-center cursor-pointer' onClick={()=>navigator(-1)}>
//         <IoIosArrowRoundBack color='#027d9b' />
//         <h6 className='text-[11px] ml-2 text-[#027d9b] font_bold'>Back to projects {}</h6>
//         </div>
//       </div>
     
//          {/* <img src={state?.banner} className={`w-screen  h-[90vh] ${(state?.image_type !== undefined && state?.image_type !== null)? 'object-contain' : 'object-cover'}`} />

//          <div className='w-[90%] md:w-[80%] mx-auto my-[5%] mb-[10%]'>
//             <h6 className='font_bold text-[25px]'>{state?.company}</h6>
//             {(state?.service !== '' && state?.service !== undefined) && <h6 className='font_normal text-[14px] mb-4'>{state?.service}</h6>}
//             {(state?.project_name !== '' && state?.project_name !== undefined) && <h6 className='font_normal text-[14px] mb-4'>PROJECT NAME : <span className='font_bold'>{state?.project_name}</span> </h6>}
//             {(state?.total_sqft !== '' && state?.total_sqft !== undefined) && <h6 className='font_normal text-[14px] mb-4'>TOTAL SFT : <span className='font_bold'>{state?.total_sqft}</span> </h6>}
//             {(state?.nature !== '' && state?.nature !== undefined) && <h6 className='font_normal text-[14px] mb-4'>NATURE OF THE PROJECT : <span className='font_bold'>{state?.nature}</span> </h6>}
//             {(state?.scope !== '' && state?.scope !== undefined) && <h6 className='font_normal text-[14px] mb-10'>SCOPE : {state?.scope}</h6>}

//             {(state?.video !== '' && state?.video !== null && state?.video !== undefined) &&
//             <video className='w-full' src={state?.video} controls />}
//          </div> */}
//          {!loader && 
//          <>
//          <img src={`${process.env.REACT_APP_AWS_IMAGE_URL}${state?.banner}`} className={`w-screen  h-[90vh] ${(state?.image_type !== undefined && state?.image_type !== null && state?.image_type !== '')? 'object-contain' : 'object-cover'}`} />

//          <div className='w-[90%] md:w-[80%] mx-auto my-[5%] mb-[10%]'>
//             <h6 className='font_bold text-[25px]'>{state?.client}</h6>
//             {(state?.work !== '' && state?.work !== undefined) && <h6 className='font_normal text-[14px] mb-4'>{state?.work}</h6>}
//             {(state?.project_name !== '' && state?.project_name !== undefined) && <h6 className='font_normal text-[14px] mb-4'>PROJECT NAME : <span className='font_bold'>{state?.project_name}</span> </h6>}
//             {(state?.total_sqft !== '' && state?.total_sqft !== undefined) && <h6 className='font_normal text-[14px] mb-4'>TOTAL SFT : <span className='font_bold'>{state?.total_sqft}</span> </h6>}
//             {(state?.nature !== '' && state?.nature !== undefined) && <h6 className='font_normal text-[14px] mb-4'>NATURE OF THE PROJECT : <span className='font_bold'>{state?.nature}</span> </h6>}
//             {(state?.scope !== '' && state?.scope !== undefined) && <h6 className='font_normal text-[14px] mb-10'>SCOPE : {state?.scope}</h6>}

//             {(state?.video !== '' && state?.video !== null && state?.video !== undefined && (state?.youtube_link == '' || state?.youtube_link == null || state?.youtube_link == undefined) ) &&
//             <video className='w-full' src={`${process.env.REACT_APP_AWS_IMAGE_URL}${state?.video}`} controls />}
            
//             {(state?.youtube_link !== '' && state?.youtube_link !== null && state?.youtube_link !== undefined ) &&
//             <div className='w-[100%] h-[100%] bg-red-100'>
//                  <iframe src={state?.youtube_link} width={'100%'} allowFullScreen />
//             </div>
//              }
            

//             <div className='grid grid-cols-2 gap-5 md:grid-cols-4'>
//             {(state?.images !== '' && state?.images !== null && state?.images !== undefined && state.images.length > 0) &&
//             state?.images?.map((s)=>(
//               <img src={`${process.env.REACT_APP_AWS_IMAGE_URL}${s}`} className='w-[100%] h-[150px] object-cover' />
//             ))
//             }
//             </div>
//          </div>
//          </>}

//     </div>

//   )
// }

// export default ProjectDetail